(() => {
  const money = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  document.querySelectorAll('[data-fv11-collection-select]').forEach((select) => {
    select.addEventListener('change', () => {
      if (select.value) window.location.assign(select.value);
    });
  });

  document.querySelectorAll('[data-fv11-sort]').forEach((select) => {
    select.addEventListener('change', () => select.form?.requestSubmit());
  });

  document.querySelectorAll('[data-fv11-product]').forEach((root) => {
    const jsonNode = root.querySelector('[data-fv11-variants]');
    const form = root.querySelector('form[action*="/cart/add"]');
    if (!jsonNode || !form) return;

    let variants = [];
    try {
      variants = JSON.parse(jsonNode.textContent || '[]');
    } catch {
      return;
    }

    const variantInput = form.querySelector('input[name="id"]');
    const price = root.querySelector('[data-fv11-price]');
    const compare = root.querySelector('[data-fv11-compare]');
    const availability = root.querySelector('[data-fv11-availability]');
    const addButton = form.querySelector('[data-fv11-add]');
    const addLabel = addButton?.querySelector('[data-fv11-add-label]');
    const addPrice = addButton?.querySelector('[data-fv11-add-price]');
    const quantityInput = form.querySelector('input[name="quantity"]');
    const mainImage = root.querySelector('.fv11-product-main-image img');
    const sticky = root.querySelector('[data-fv11-sticky]');
    const stickyLabel = sticky?.querySelector('[data-fv11-sticky-label]');
    const stickyPrice = sticky?.querySelector('[data-fv11-sticky-price]');
    const stickyButton = sticky?.querySelector('[data-fv11-sticky-submit]');
    const purchaseRow = root.querySelector('[data-fv11-purchase-row]');
    const related = root.querySelector('[data-fv11-related]');

    const selectedOptions = () => [...root.querySelectorAll('[data-fv11-option-group]')].map((group) => {
      const pressed = group.querySelector('[data-fv11-option][aria-pressed="true"]');
      return pressed?.dataset.value || '';
    });

    const scoreVariant = (variant, desired, changedIndex) => variant.options.reduce((score, value, index) => (
      score + Number(index !== changedIndex && value === desired[index])
    ), 0);

    const chooseVariant = (desired, changedIndex) => {
      const exact = variants.filter((variant) => variant.options.every((value, index) => value === desired[index]));
      const exactAvailable = exact.find((variant) => variant.available);
      if (exactAvailable) return exactAvailable;
      if (exact[0]) return exact[0];

      const matchingValue = variants
        .filter((variant) => variant.options[changedIndex] === desired[changedIndex])
        .sort((left, right) => {
          const availabilityOrder = Number(right.available) - Number(left.available);
          if (availabilityOrder) return availabilityOrder;
          return scoreVariant(right, desired, changedIndex) - scoreVariant(left, desired, changedIndex);
        });
      return matchingValue[0] || variants.find((variant) => variant.available) || variants[0];
    };

    const variantImage = (variant) => variant?.featured_image?.src || variant?.featured_image || '';

    const syncButtons = (variant) => {
      root.querySelectorAll('[data-fv11-option-group]').forEach((group, index) => {
        group.querySelectorAll('[data-fv11-option]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.value === variant.options[index]));
        });
        const current = group.querySelector('[data-fv11-option-current]');
        if (current) current.textContent = variant.options[index] || '';
      });
    };

    const updateProduct = (variant) => {
      if (!variant) return;
      const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
      const available = Boolean(variant.available);
      const imageUrl = variantImage(variant);

      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = money.format(variant.price / 100);
      if (compare) {
        const showCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        compare.textContent = showCompare ? money.format(variant.compare_at_price / 100) : '';
        compare.hidden = !showCompare;
      }
      if (availability) {
        availability.textContent = available ? 'Available' : 'Sold out';
        availability.dataset.available = String(available);
      }
      if (addButton) addButton.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';
      if (addPrice) addPrice.textContent = available ? money.format((variant.price * quantity) / 100) : '';
      if (stickyButton) stickyButton.disabled = !available;
      if (stickyLabel) stickyLabel.textContent = variant.title || 'Selected option';
      if (stickyPrice) stickyPrice.textContent = money.format((variant.price * quantity) / 100);
      if (imageUrl && mainImage) mainImage.src = imageUrl;
      syncButtons(variant);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    root.querySelectorAll('[data-fv11-option]').forEach((button) => {
      button.addEventListener('click', () => {
        const changedIndex = Number(button.dataset.index);
        const desired = selectedOptions();
        desired[changedIndex] = button.dataset.value || '';
        updateProduct(chooseVariant(desired, changedIndex));
      });
    });

    root.querySelectorAll('[data-fv11-thumbnail]').forEach((button) => {
      button.addEventListener('click', () => {
        const imageUrl = button.dataset.image;
        if (imageUrl && mainImage) mainImage.src = imageUrl;
        root.querySelectorAll('[data-fv11-thumbnail]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === button));
        });
      });
    });

    root.querySelectorAll('[data-fv11-quantity-action]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!quantityInput) return;
        const current = Math.max(1, Number.parseInt(quantityInput.value || '1', 10) || 1);
        const next = button.dataset.fv11QuantityAction === 'increase' ? current + 1 : Math.max(1, current - 1);
        quantityInput.value = String(next);
        const currentVariant = variants.find((variant) => String(variant.id) === String(variantInput?.value));
        updateProduct(currentVariant || variants[0]);
      });
    });

    quantityInput?.addEventListener('change', () => {
      quantityInput.value = String(Math.max(1, Number.parseInt(quantityInput.value || '1', 10) || 1));
      const currentVariant = variants.find((variant) => String(variant.id) === String(variantInput?.value));
      updateProduct(currentVariant || variants[0]);
    });

    stickyButton?.addEventListener('click', () => form.requestSubmit());

    if (sticky && purchaseRow) {
      let frame = 0;
      const renderSticky = () => {
        const purchasePassed = purchaseRow.getBoundingClientRect().bottom < 0;
        const relatedVisible = related ? related.getBoundingClientRect().top < window.innerHeight : false;
        const isVisible = purchasePassed && !relatedVisible;
        sticky.dataset.visible = String(isVisible);
        document.body.classList.toggle('fv11-sticky-buy-active', isVisible);
      };
      const scheduleStickyRender = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(() => {
          frame = 0;
          renderSticky();
        });
      };
      window.addEventListener('scroll', scheduleStickyRender, { passive: true });
      window.addEventListener('resize', scheduleStickyRender);
      renderSticky();
    }

    const initial = variants.find((variant) => String(variant.id) === String(variantInput?.value))
      || variants.find((variant) => variant.available)
      || variants[0];
    updateProduct(initial);
  });

  document.querySelectorAll('[data-fv11-cart-quantity]').forEach((control) => {
    const input = control.querySelector('input');
    if (!input) return;
    control.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const current = Math.max(0, Number.parseInt(input.value || '0', 10) || 0);
        input.value = String(button.dataset.direction === 'increase' ? current + 1 : Math.max(0, current - 1));
      });
    });
  });
})();
